/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — assets/cp-jonction.js (chargé par snippets/cp-decor-data.liquid)
   JONCTION D'ANGLE (forme en L) — droite ou coupe à 45°
   Sélecteur visible dans la barre au-dessus du dessin (#stage-toolbar) ; en L :
       « Retour filant » = junctionType 'flush' (le retour va jusqu'au mur)
       « Plan filant » = junctionType 'overlap' (le plan principal passe)
       « Coupe à 45° » = S.cpJ45 (onglet de l'angle intérieur à l'angle extérieur)
     En U et en G, chaque choix porte le nom de la pièce qui couvre le coin.
     Un clic sur la ligne de jonction du dessin fait tourner les 3 choix.
   45° conseillée quand le décor a c45 = true.
   Prix : window.CP_PRODUCT.j45 (métachamp produit custom.prix_jonction_45).
     0 = sans supplément.
     Métachamp absent : option affichée « sur devis » et NON commandable.
   Longueur facturée inchangée (L1 + L2) : en coupe à 45°, chaque pièce
     va jusqu'à l'angle extérieur, soit exactement L1 et L2.
   La jonction choisie part dans la commande (propriété « Jonction »),
     pour les formes en L, en U et en G.
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  var LABELS = { flush: 'Retour filant', overlap: 'Plan filant', j45: 'Coupe à 45°' };

  function getApp() { try { return (typeof App !== 'undefined') ? App : window.App; } catch (e) { return window.App; } }
  /* règle du produit (custom-configV2 : jonction45 { eur, unite }) ; son prix passe avant celui du produit */
  function regle() {
    var A = getApp(), id = Number(A && A._eff && A._eff.matchedCollectionId) || 0, rs = (window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.collectionRules) || [];
    for (var i = 0; i < rs.length; i++) if (Number(rs[i].collectionId) === id) return rs[i];
    return null;
  }
  function j45Regle() { var r = regle(); return (r && r.jonction45) || {}; }
  /* null = pas de donnée (sur devis) ; 0 = sans supplément ; > 0 = supplément en € */
  function price45() {
    var r = j45Regle(), v = (r.eur !== null && r.eur !== undefined && r.eur !== '') ? r.eur : (window.CP_PRODUCT && window.CP_PRODUCT.j45);
    if (v === null || v === undefined || v === '') return null;
    var n = Number(v);
    return (isFinite(n) && n >= 0) ? n : null;
  }
  function has45() { return price45() !== null && !off45(); }
  function decor() { return (typeof window.CP_currentDecor === 'function') ? window.CP_currentDecor() : null; }
  /* décor sans coupe à 45° (variante : jonction_45 à faux) : le choix n'est pas proposé, ni devis ni blocage */
  function off45() { var d = decor(), raw = d && window.CP_DECORS && window.CP_DECORS[d.name]; return !!(raw && raw.n45); }
  function fmt(cents) { return (cents / 100).toFixed(2).replace('.', ','); }
  /* coins réglables par forme :
     clé de l'état du moteur, drapeau 45° (S.cpJ45 en L, S.cpJ45U[g|d] en U), identifiant de la
     ligne de jonction du moteur (addJunctionLine)*/
  /*  chaque choix porte le nom de la pièce qui couvre réellement le coin (relevé
     sur CP_plan : en G, 'flush' fait filer le montant au coin haut gauche et au retour, mais le plan du haut au
     coin haut droite). nf = nom du choix 'flush' du moteur, no = nom du choix 'overlap'. Seul l'affichage change :
     tuile (aria-label), infobulle, nom du choix actif et propriété « Jonction » de la commande.*/
  var CORNERS = {
    angle: [{ c: 'L', t: 'Jonction d\'angle', eng: 'junctionType', jid: 'default', nf: 'Retour filant', no: 'Plan filant' }],
    'u-shape': [{ c: 'g', st: 'cpJ45U', t: 'Jonction gauche', eng: 'junctionLeftU', jid: 'leftU', nf: 'Jambe filante', no: 'Fond filant' },
                { c: 'd', st: 'cpJ45U', t: 'Jonction droite', eng: 'junctionRightU', jid: 'rightU', nf: 'Jambe filante', no: 'Fond filant' }],
    'g-shape': [{ c: 'top', st: 'cpJ45G', t: 'Jonction haut gauche', eng: 'junctionTopG', jid: 'topG', nf: 'Montant filant', no: 'Plan filant',
                  tf: 'Le montant va jusqu\'au mur du fond ; le plan du haut s\'arrête contre lui.', to: 'Le plan du haut passe tout du long ; le montant s\'arrête contre lui.' },
                { c: 'mid', st: 'cpJ45G', t: 'Jonction haut droite', eng: 'junctionMidG', jid: 'midG', nf: 'Plan filant', no: 'Montant filant',
                  tf: 'Le plan du haut passe tout du long ; le montant s\'arrête contre lui.', to: 'Le montant va jusqu\'au mur du fond ; le plan du haut s\'arrête contre lui.' },
                { c: 'ret', st: 'cpJ45G', t: 'Jonction du retour', eng: 'junctionReturnG', jid: 'returnG', nf: 'Montant filant', no: 'Retour filant',
                  tf: 'Le montant passe tout du long ; le retour s\'arrête contre lui.', to: 'Le retour va jusqu\'au bord du montant ; le montant s\'arrête contre lui.' }]
  };
  function nameOf(k, m) { return m === 'j45' ? LABELS.j45 : (m === 'overlap' ? k.no : k.nf); }
  var BY_JID = {}; ['u-shape', 'g-shape'].forEach(function (f) { CORNERS[f].forEach(function (k) { BY_JID[k.jid] = k; }); });
  function is45(A, k) { return k.c === 'L' ? !!A.S.cpJ45 : !!(A.S[k.st] && A.S[k.st][k.c]); }
  function set45(A, k, on) { if (k.c === 'L') A.S.cpJ45 = on; else { A.S[k.st] = A.S[k.st] || {}; A.S[k.st][k.c] = on; } }
  function modeOf(A, k) { return is45(A, k) ? 'j45' : (A.S[k.eng] === 'overlap' ? 'overlap' : 'flush'); }
  function mode(A) { return modeOf(A, CORNERS.angle[0]); }
  function n45(A) { var l = CORNERS[A.S.layout] || []; return l.filter(function (k) { return is45(A, k); }).length; }
  /* quantité facturée : coins coupés à 45°, ou (règle « par pièce ») pièces touchées par au moins un de ces coins
     (L : plan et retour ; U : jambe et fond de chaque côté ; G : les deux pièces de chaque coin, le retour avec son montant) */
  function nbFacture45(A) {
    if (j45Regle().unite !== 'piece') return n45(A);
    var S = A.S, p = {};
    if (S.layout === 'angle') { if (S.cpJ45) { p.plan = 1; p.retour = 1; } }
    else if (S.layout === 'u-shape') { var u = S.cpJ45U || {}; if (u.g) { p.gauche = 1; p.fond = 1; } if (u.d) { p.fond = 1; p.droite = 1; } }
    else if (S.layout === 'g-shape') {
      var g = S.cpJ45G || {}, por = S.gDir === 'left' ? 'gauche' : 'droite';
      if (g.top) { p.gauche = 1; p.haut = 1; } if (g.mid) { p.haut = 1; p.droite = 1; } if (g.ret) { p[por] = 1; p.retour = 1; }
    }
    return Object.keys(p).length;
  }
  window.CP_j45 = { prix: function () { return price45(); }, off: function () { return off45(); } };

  /*  la coupe à 45° n'est
     proposée qu'à 90°. Angle du coin : L = S.innerAngle (moteur) ; U et G = S.cpAng[forme][coin] (cp-trace), mêmes clés
     que les coins de jonction (g, d ; top, mid, ret).*/
  var MSG_90 = 'Coupe à 45° possible seulement à 90°';
  function angleOf(A, k) {
    var S = A.S, v;
    if (k.c === 'L') v = Number(S.innerAngle);
    else { var c = S.cpAng && S.cpAng[S.layout]; v = c ? Number(c[k.c]) : 90; }
    return v > 0 ? v : 90;
  }
  function square(A, k) { return Math.abs(angleOf(A, k) - 90) < 0.01; }
  function note90(msg) { try { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(msg, 'info', 6000); } catch (e) {} }
  function orderOf(A, k) { return (has45() && square(A, k)) ? ['flush', 'overlap', 'j45'] : ['flush', 'overlap']; }

  function setModeOf(A, k, m) {
    if (m === 'j45' && !has45()) return;
    if (m === 'j45' && !square(A, k)) { note90(MSG_90 + ' (' + String(angleOf(A, k)).replace('.', ',') + '° ici).'); return; }
    set45(A, k, m === 'j45');
    A.S[k.eng] = (m === 'overlap') ? 'overlap' : 'flush';
    if (typeof updateTdForme === 'function') updateTdForme();
    A.render();
  }
  function setMode(A, m) { setModeOf(A, CORNERS.angle[0], m); }

  function injectCss() {
    if (document.getElementById('cp-j45-css')) return;
    var st = document.createElement('style');
    st.id = 'cp-j45-css';
    st.textContent =
      '.cp-jct{display:flex;align-items:center;column-gap:1.75rem;row-gap:.6rem;flex-wrap:wrap;font-size:.8rem}' +   /*  un vrai espace entre les coins*/
      '.cp-jct[hidden]{display:none}.cp-jct button[hidden]{display:none!important}' +
      '.cp-jct__t{font-weight:600;color:#374151}' +
      '.cp-jct button{display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;min-width:48px;min-height:44px;' +
        'border:1px solid #d1d5db;background:#fff;color:#1d4a36;border-radius:8px;padding:4px 8px;cursor:pointer;font:inherit;line-height:1.1}' +
      '.cp-jct button[aria-pressed="true"]{background:#1d4a36;border-color:#1d4a36;color:#fff}' +
      '.cp-jct button:disabled{opacity:.5;cursor:not-allowed}' +
      '.cp-jct button:focus-visible{outline:2px solid #80602f;outline-offset:2px}' +
      '.cp-jct__ico{display:block;width:32px;height:32px}' +
      '.cp-jct__sub{font-size:.68rem;font-weight:600;white-space:nowrap}' +
      '.cp-jct__tag{font-size:.64rem;background:#fde68a;color:#78350f;border-radius:999px;padding:0 .4rem;white-space:nowrap}' +
      '.cp-jct__note{flex-basis:100%;color:#92400e;font-size:.75rem}' +
      '.cp-jct__row{display:flex;align-items:center;gap:.4rem;flex-wrap:wrap}' +
      /*  tuiles de même taille (la coupe à 45° était plus haute), colonnes alignées d'un coin à
         l'autre (libellé en colonne de largeur fixe), nom du choix actif après le nom du coin, sous lui en colonne, sur la même ligne au-dessus des tuiles sur
         téléphone. Sélecteurs à identifiant : passent devant #cp-jct button de cp-style.*/
      '#cp-jct .cp-jct__row{gap:6px;flex-wrap:nowrap}' +
      '#cp-jct .cp-jct__t{display:flex;flex-direction:column;flex:0 0 11.75em;width:11.75em;line-height:1.25}' +
      '#cp-jct .cp-jct__cur{font-weight:500;color:#0d3527}' +
      '#cp-jct .cp-jct__row > button{width:56px;height:56px;min-height:0;padding:4px;flex:0 0 auto}' +
      '#cp-jct .cp-jct__row > button .cp-jct__ico{width:28px;height:28px}' +
      '#cp-jct .cp-jct__row > button .cp-jct__sub{font-size:10.5px}' +
      /* A-346 : un petit texte long (« 90° seulement ») tient dans la tuile, sur 2 lignes, l'icône réduite ; il ne déborde plus
         sur la tuile voisine. Tuiles de même taille */
      '#cp-jct .cp-jct__row > button.cp-jct--2l .cp-jct__ico{width:22px;height:22px}' +
      '#cp-jct .cp-jct__row > button.cp-jct--2l .cp-jct__sub{white-space:normal;text-align:center;font-size:9.5px;line-height:1.05;letter-spacing:-.01em}' +
      '#cp-jct .cp-jct__row > .cp-jct__tag{margin-left:2px;align-self:center}' +
      '@media (max-width:480px){#cp-jct .cp-jct__row{flex-wrap:wrap}' +
        '#cp-jct .cp-jct__t{display:block;flex:0 0 100%;width:auto}}';
    document.head.appendChild(st);
  }

  /*  des pictogrammes plutôt que des mots. Chaque choix dessine les deux pièces
     qui se rejoignent : la pièce filante entière, l'autre arrêtée contre elle, ou la coupe en diagonale (45°). Pièce
     horizontale claire, pièce verticale foncée. Orientation du coin réel (lignes de jonction du moteur, render-g
     l. 831-878) : L droit ┐, L gauche ┌ ; U gauche ┌, droite ┐ ; G : haut gauche ┌, haut droite ┐, retour ┘ en G
     droit, └ en G gauche. Le nom reste en aria-label et en infobulle ; sous la coupe à 45°, seulement « +X € » ou « sur devis ».
     Pièce filante dessinée : la verticale pour le choix 'flush' du moteur, sauf au coin haut droite du G.
      relevé sur le dessin, en G gauche aussi, topG est en haut à gauche et midG en haut à
     droite, avec la même pièce filante qu'en G droit ; seul le retour passe en bas à gauche.*/
  function orientOf(A, k) {
    var left = A.S.gDir === 'left';
    return ({ L: A.S.angleDir === 'left' ? 'tl' : 'tr', g: 'tl', d: 'tr', top: 'tl', mid: 'tr', ret: left ? 'bl' : 'br' })[k.c] || 'tr';
  }
  /* A-346 : petit texte de tuile trop long pour une ligne de la tuile (« 90° seulement ») : sur 2 lignes */
  function sousLong(sub) { var t = String(sub || '').trim(); return t.length > 9 && /\s/.test(t); }
  function jIcon(m, orient, hFlush) {
    var hFull = m === 'overlap' ? !hFlush : hFlush, H, V;
    if (m === 'j45') { H = 'M3 5H29L20 14H3Z'; V = 'M29 5V29H20V14Z'; }
    else if (hFull) { H = 'M3 5H29V14H3Z'; V = 'M20 14H29V29H20Z'; }
    else { H = 'M3 5H20V14H3Z'; V = 'M20 5H29V29H20Z'; }
    var tf = ({ tr: '', tl: 'matrix(-1 0 0 1 32 0)', br: 'matrix(1 0 0 -1 0 32)', bl: 'matrix(-1 0 0 -1 32 32)' })[orient] || '';
    return '<svg class="cp-jct__ico" viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" focusable="false">' +
      '<g' + (tf ? ' transform="' + tf + '"' : '') + ' stroke="currentColor" stroke-width="1.5" stroke-linejoin="round">' +
      '<path d="' + H + '" fill="currentColor" fill-opacity=".18"/><path d="' + V + '" fill="currentColor" fill-opacity=".55"/></g></svg>';
  }

  /* Barre de choix au-dessus du dessin : une ligne par coin (L : 1 ; U : gauche et droite) */
  function syncToolbar(A) {
    var bar = document.getElementById('stage-toolbar');
    if (!bar) return;
    injectCss();
    var list = CORNERS[A.S.layout], box = document.getElementById('cp-jct');
    if (!box) {
      box = document.createElement('div');
      box.id = 'cp-jct';
      box.className = 'cp-jct';
      var spacer = bar.querySelector('.stage-toolbar-spacer');
      bar.insertBefore(box, spacer || null);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-m]'), B = getApp();
        var k = b && (CORNERS[B.S.layout] || []).filter(function (x) { return x.c === b.dataset.c; })[0];
        if (!(b && k && !b.disabled)) return;
        var plus = window.CP_jonctionPlus;
        if (b.hasAttribute('data-plus')) { if (plus && plus.choisir) plus.choisir(B, k, b.dataset.m); B.render(); return; }
        if (plus && plus.actif && plus.actif(B, k) && plus.choisir) plus.choisir(B, k, null);   /* retour aux choix du moteur */
        setModeOf(B, k, b.dataset.m);
      });
    }
    box.hidden = !list;
    if (!list) return;
    if (box.getAttribute('data-forme') !== A.S.layout) {
      box.setAttribute('data-forme', A.S.layout);
      box.innerHTML = list.map(function (k) {
        return '<div class="cp-jct__row" role="group" aria-label="' + k.t + '" data-c="' + k.c + '"><span class="cp-jct__t"><span>' + k.t + ' :</span> ' +
          '<span class="cp-jct__cur"></span></span>' +
          ['flush', 'overlap', 'j45'].map(function (m) { return '<button type="button" data-c="' + k.c + '" data-m="' + m + '"></button>'; }).join('') +
          '<span class="cp-jct__tag" hidden>conseillée</span></div>';
      }).join('') + '<span class="cp-jct__note"></span>';
    }
    var p = price45(), d = decor(), advised = !!(d && d.c45), U = A.S.layout === 'u-shape';
    Array.prototype.forEach.call(box.querySelectorAll('button[data-m]'), function (b) {
      var k = list.filter(function (x) { return x.c === b.dataset.c; })[0], m = b.dataset.m;
      if (!k) return;
      b.setAttribute('aria-pressed', String(m === modeOf(A, k)));
      var ico = jIcon(m, orientOf(A, k), k.c === 'mid'), expl;
      if (m === 'j45') {
        var sq = square(A, k);                                              /*  90° seulement*/
        b.disabled = (p === null) || !sq;
        /*
           sans supplément, rien sous le pictogramme, comme pour les deux autres jonctions ; « +X € » ou « non proposée en ligne » sinon (lot « messages 2 », N37)*/
        var sub = !sq ? '90° seulement' : p === null ? 'non proposée en ligne' : (p > 0 ? '+' + fmt(Math.round(p * 100)) + ' €' : '');
        b.innerHTML = ico + (sub ? '<span class="cp-jct__sub">' + sub + '</span>' : '');   /* « conseillée » : à côté des tuiles*/
        b.classList.toggle('cp-jct--2l', sousLong(sub));                  /* A-346 */
        b.setAttribute('aria-label', LABELS.j45 + (sub ? ' (' + sub + ')' : '') + (advised ? ', conseillée' : ''));
        expl = !sq ? MSG_90 + ' ; cet angle est à ' + String(angleOf(A, k)).replace('.', ',') + '°.'
             : (p !== null) ? (U ? 'La jambe et le fond sont coupés en onglet, de l\'angle intérieur à l\'angle extérieur.'
                                 : 'Les deux pièces sont coupées en onglet, de l\'angle intérieur à l\'angle extérieur.')
                            : 'choisissez une autre jonction, ou écrivez-nous.';   /* N38 : le plan reste commandable avec une autre jonction */
        b.title = LABELS.j45 + (sub ? ' (' + sub + ')' : '') + ' : ' + expl;
      } else {
        b.innerHTML = ico;
        b.setAttribute('aria-label', nameOf(k, m));
        expl = k.tf ? (m === 'flush' ? k.tf : k.to) : U ? (m === 'flush' ? 'La jambe va jusqu\'au mur du fond ; le fond s\'arrête contre elle.'
                                     : 'Le fond va jusqu\'au mur de la jambe ; la jambe s\'arrête contre lui.')
                    : (m === 'flush' ? 'Le retour va jusqu\'au mur ; le plan principal s\'arrête contre lui.'
                                     : 'Le plan principal va jusqu\'au mur ; le retour s\'arrête contre lui.');
        b.title = nameOf(k, m) + ' : ' + expl;
      }
    });
    Array.prototype.forEach.call(box.querySelectorAll('.cp-jct__row'), function (row) {   /*  nom du choix actif*/
      var k = list.filter(function (x) { return x.c === row.getAttribute('data-c'); })[0]; if (!k) return;
      var cur = row.querySelector('.cp-jct__cur'), tag = row.querySelector('.cp-jct__tag'), name = nameOf(k, modeOf(A, k));
      if (cur && cur.textContent !== name) cur.textContent = name;
      if (tag) tag.hidden = !advised;
    });
    /* choix d'un autre module pour un coin (window.CP_jonctionPlus : modes, actif, choisir, masquer45 ; pièce d'angle
       de la pierre) : tuiles ajoutées après celles du moteur ; le choix actif l'emporte. Sans lui, rien ne change. */
    var plus = window.CP_jonctionPlus;
    Array.prototype.forEach.call(box.querySelectorAll('.cp-jct__row'), function (row) {
      var k = list.filter(function (x) { return x.c === row.getAttribute('data-c'); })[0]; if (!k) return;
      var ms = (plus && typeof plus.modes === 'function') ? (plus.modes(A, k) || []) : [], vus = {};
      ms.forEach(function (o) {
        vus[o.m] = true;
        var b = row.querySelector('button[data-plus][data-m="' + o.m + '"]');
        if (!b) {
          b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-c', k.c); b.setAttribute('data-m', o.m); b.setAttribute('data-plus', '1');
          row.insertBefore(b, row.querySelector('.cp-jct__tag'));
        }
        b.disabled = !!o.disabled;
        var h = (o.ico || '') + (o.sub ? '<span class="cp-jct__sub">' + o.sub + '</span>' : '');
        if (b.innerHTML !== h) b.innerHTML = h;
        b.classList.toggle('cp-jct--2l', sousLong(o.sub));                /* A-346 */
        b.setAttribute('aria-label', o.label + (o.sub ? ' (' + o.sub + ')' : ''));
        b.title = o.title || o.label;
      });
      Array.prototype.forEach.call(row.querySelectorAll('button[data-plus]'), function (b) { if (!vus[b.dataset.m]) b.parentNode.removeChild(b); });
      var actif = (plus && typeof plus.actif === 'function') ? plus.actif(A, k) : null;
      Array.prototype.forEach.call(row.querySelectorAll('button[data-plus]'), function (b) { b.setAttribute('aria-pressed', String(b.dataset.m === actif)); });
      if (actif) {
        Array.prototype.forEach.call(row.querySelectorAll('button[data-m]:not([data-plus])'), function (b) { b.setAttribute('aria-pressed', 'false'); });
        var o = ms.filter(function (x) { return x.m === actif; })[0], cur = row.querySelector('.cp-jct__cur');
        if (o && cur && cur.textContent !== o.label) cur.textContent = o.label;
      }
      var j = row.querySelector('button[data-m="j45"]');
      if (j) j.hidden = off45() || !!(plus && typeof plus.masquer45 === 'function' && plus.masquer45(A));
    });
    var note = box.querySelector('.cp-jct__note');
    note.textContent = (advised && n45(A) < list.length)
      ? 'Pour le décor « ' + d.name + ' », le fabricant conseille la coupe à 45° dans les angles (veinage continu).'
      : '';
  }

  /* Dessin : remplace la ligne de jonction par la diagonale et pose le fil
     du plan principal sur le triangle qui lui revient. */
  function drawMiter(A) {
    var svg = A.svg; if (!svg) return;
    var S = A.S, L1 = Number(S.L1) || 0, P1 = Number(S.P1) || 0, P2 = Number(S.P2) || 0;
    var blocks = Array.prototype.filter.call(svg.children, function (n) {
      return n.tagName === 'g' && /clip-assembly/.test(n.getAttribute('clip-path') || '');
    });
    var main = blocks[0] && blocks[0].firstElementChild;
    if (!main) return;
    /* origine du plan principal : x/y de son bloc (image ou rect de secours) */
    var x0 = Number(main.getAttribute('x')), y0 = Number(main.getAttribute('y'));
    var right = S.angleDir === 'right';
    var inner = right ? [x0 + L1 - P2, y0 + P1] : [x0 + P2, y0 + P1];
    var outer = right ? [x0 + L1, y0] : [x0, y0];
    var tri = right
      ? [[x0 + L1 - P2, y0], [x0 + L1, y0], [x0 + L1 - P2, y0 + P1]]
      : [[x0, y0], [x0 + P2, y0], [x0 + P2, y0 + P1]];

    var NS = 'http://www.w3.org/2000/svg';
    var defs = svg.querySelector('defs') || svg.insertBefore(document.createElementNS(NS, 'defs'), svg.firstChild);
    var old = svg.querySelector('#cp-miter-clip'); if (old) old.remove();
    var cp = document.createElementNS(NS, 'clipPath'); cp.id = 'cp-miter-clip';
    var poly = document.createElementNS(NS, 'polygon');
    poly.setAttribute('points', tri.map(function (p) { return p.join(','); }).join(' '));
    cp.appendChild(poly); defs.appendChild(cp);

    var g = document.createElementNS(NS, 'g');
    g.setAttribute('clip-path', 'url(#cp-miter-clip)');
    g.setAttribute('class', 'cp-miter-fill');
    g.appendChild(main.cloneNode(true));
    var jg = svg.querySelector('.junction-group');
    svg.insertBefore(g, jg || (blocks[1] ? blocks[1].nextSibling : null));

    if (jg) {
      Array.prototype.forEach.call(jg.querySelectorAll('line'), function (l) {
        l.setAttribute('x1', inner[0]); l.setAttribute('y1', inner[1]);
        l.setAttribute('x2', outer[0]); l.setAttribute('y2', outer[1]);
      });
      var ln = jg.querySelector('.junction-line'); if (ln) ln.setAttribute('class', 'junction-line flush cp-miter');
    }
  }

  /* Clic sur la ligne de jonction (forme en L) : 3 choix au lieu de 2 */
  function rebindJunctionClick(A) {
    var jg = A.svg && A.svg.querySelector('.junction-group');
    if (!jg) return;
    var fresh = jg.cloneNode(true);           /* le clone n'a plus l'écouteur du moteur */
    jg.parentNode.replaceChild(fresh, jg);
    fresh.addEventListener('click', function (e) {
      e.stopPropagation();
      var order = orderOf(A, CORNERS.angle[0]);                            /*  sans 45° hors d'équerre*/
      var i = order.indexOf(mode(A));
      setMode(A, order[(i + 1) % order.length]);
    });
  }

  /* propriété « Jonction » de la commande : mêmes noms que la barre.
      en L, plus de préfixe « Droite – » (écrit en dur, faux en L gauche) ; le côté est dans « Forme ».*/
  function junctionText(A) {
    if (typeof window.CP_sansJonction === 'function' && window.CP_sansJonction(A)) return '';   /* pierre en L et en U (cp-pierre-angle) */
    var S = A.S, plus = window.CP_jonctionPlus, word = function (k) {
      var a = plus && typeof plus.actif === 'function' ? plus.actif(A, k) : null;
      if (a) { var o = (plus.modes(A, k) || []).filter(function (x) { return x.m === a; })[0]; if (o) return o.label; }
      var m = modeOf(A, k); return m === 'j45' ? 'Coupe à 45° (onglet)' : nameOf(k, m);
    };
    if (S.layout === 'angle') return word(CORNERS.angle[0]);
    if (S.layout === 'u-shape') return CORNERS['u-shape'].map(function (k) {
      return (k.c === 'g' ? 'Gauche : ' : 'Droite : ') + word(k);
    }).join(' · ');
    if (S.layout === 'g-shape') return CORNERS['g-shape'].map(function (k) {
      return ({ top: 'Haut gauche : ', mid: 'Haut droite : ', ret: 'Retour : ' })[k.c] + word(k);
    }).join(' · ');
    return '';
  }

  /*  la jonction choisie (coupe à 45°, retour filant…) n'était ni au récapitulatif ni dans la
     fenêtre « Ajouté », seulement dans le panier. Ligne « Jonction » sous « Forme », mêmes mots que la propriété de la
     commande ; cachée en forme droite (classe « hidden » du moteur : rien ne bouge au chargement).*/
  window.CP_jonction = function () { var B = getApp(); return (B && B.S) ? junctionText(B) : ''; };
  function recapRow(A) {
    var f = document.getElementById('td-forme'), item = f && f.closest ? f.closest('.recap-item') : null;
    if (!item || !item.parentNode) return;
    var row = document.getElementById('cp-recap-jonction');
    if (!row) {
      row = document.createElement('div'); row.className = 'recap-item hidden'; row.id = 'cp-recap-jonction';
      row.innerHTML = '<span class="recap-label">Jonction</span><span class="recap-value" id="td-jonction"></span>';
      item.parentNode.insertBefore(row, item.nextSibling);
    }
    var t = junctionText(A), v = row.querySelector('#td-jonction');
    if (v.textContent !== t) v.textContent = t;
    row.classList.toggle('hidden', !t);
  }

  function wrap(A) {
    if (A.__cpJctWrapped) return;
    A.__cpJctWrapped = true;

    /* lignes de jonction du moteur : marquées par coin (data-cp-jn) ; en U, un clic fait tourner les
       3 choix (le moteur n'en connaît que 2). Le repère bombé (drawJunction) suit la ligne qui le précède. */
    var lastJid = null, oJL = A.addJunctionLine, oDJ = A.drawJunction;
    if (typeof oJL === 'function') A.addJunctionLine = function (x1, y1, x2, y2, jid) {
      var svg = this.svg, before = svg && svg.lastChild, r = oJL.apply(this, arguments), g = svg && svg.lastChild;
      lastJid = jid || 'default';
      if (g && g !== before && g.getAttribute && /junction-group/.test(g.getAttribute('class') || '')) {
        g.setAttribute('data-cp-jn', lastJid);
        var k = BY_JID[lastJid], B = this;
        if (k) {
          var fresh = g.cloneNode(true);                                   /* sans l'écouteur du moteur (2 choix) */
          g.parentNode.replaceChild(fresh, g);
          fresh.addEventListener('click', function (e) {
            e.stopPropagation();
            var order = orderOf(B, k), i = order.indexOf(modeOf(B, k));     /*  sans 45° hors d'équerre*/
            setModeOf(B, k, order[(i + 1) % order.length]);
          });
        }
      }
      return r;
    };
    if (typeof oDJ === 'function') A.drawJunction = function () {
      var svg = this.svg, before = svg && svg.lastChild, r = oDJ.apply(this, arguments), g = svg && svg.lastChild;
      if (g && g !== before && g.setAttribute && lastJid) g.setAttribute('data-cp-jn', lastJid);
      return r;
    };

    var origRender = A.render;
    A.render = function () {
      var S = this.S;
      if (off45() && n45(this) > 0) note90('Coupe à 45° non proposée pour ce décor : jonction remise en « filant ».');
      if (S.cpJ45 && (S.layout !== 'angle' || !has45())) S.cpJ45 = false;
      if (S.cpJ45) S.junctionType = 'flush';
      ['u-shape', 'g-shape'].forEach(function (f) {                         /*  onglet = moteur en « retour filant » ;*/
        CORNERS[f].forEach(function (k) {                                   /* hors de sa forme, oublié (comme en L) */
          var st = S[k.st]; if (!st) return;
          if (st[k.c] && (S.layout !== f || !has45())) st[k.c] = false;
          if (st[k.c]) S[k.eng] = 'flush';
        });
      });
      /*  coin passé hors d'équerre avec une coupe à 45° : retour au choix « filant » (Retour filant en L), avec
         un message ; le modèle et la requête d'ajout suivent l'état*/
      var B = this;
      (CORNERS[S.layout] || []).forEach(function (k) {
        if (is45(B, k) && !square(B, k)) {
          set45(B, k, false); S[k.eng] = 'flush';
          note90(MSG_90 + ' : ' + k.t.toLowerCase() + ' remise en « ' + nameOf(k, 'flush') + ' » (' + String(angleOf(B, k)).replace('.', ',') + '°).');
        }
      });
      lastJid = null;
      var r = origRender.apply(this, arguments);
      try {
        if (this.S.layout === 'angle') {
          if (this.S.cpJ45) drawMiter(this);
          rebindJunctionClick(this);
        }
        syncToolbar(this);
        recapRow(this);                                                      
        if (typeof window.CP_placeStageExtras === 'function') window.CP_placeStageExtras();   /*  sous le dessin sur mobile*/
      } catch (e) { console.warn('[cp-jct]', e); }
      return r;
    };

    /* Supplément : ajouté APRÈS le calcul du moteur, dans le même total
       (S.optionsTotalCents), donc repris par le prix affiché, le panier et
       le contrôle d'intégrité. */
    var origOpts = A.updateTdOptionsList;
    A.updateTdOptionsList = function () {
      var r = origOpts.apply(this, arguments), nb = nbFacture45(this);
      if (nb > 0 && price45() > 0) {                                       /* un supplément par coin (ou par pièce) coupé à 45° */
        var u = Math.round(price45() * 100), c = u * nb;
        this.S.optionsTotalCents = Number(this.S.optionsTotalCents || 0) + c;
        var td = document.getElementById('td-options');
        if (td) {
          var line = (j45Regle().unite === 'piece' ? 'Coupe à 45°, par pièce' : 'Jonction d\'angle coupe à 45°') + ' : ' + (nb > 1 ? nb + ' × ' + fmt(u) + ' € = +' + fmt(c) : '+' + fmt(u)) + ' €';   /* lot « messages 2 », N14 */
          var ul = td.querySelector('.td-options-list');
          if (ul) {
            var li = document.createElement('li'); li.textContent = line; ul.appendChild(li);
            var sum = td.querySelector('.td-options-dropdown > summary');
            if (sum) sum.textContent = 'Suppléments : +' + fmt(this.S.optionsTotalCents) + '€';
          } else {
            td.innerHTML = '<details class="td-options-dropdown" open><summary>Suppléments : +' + fmt(this.S.optionsTotalCents) +
              '€</summary><div class="td-options-scroll"><ul class="td-options-list"><li></li></ul></div></details>';
            td.querySelector('li').textContent = line;
          }
        }
      }
      return r;
    };

    /*  la propriété « Forme » (texte du récapitulatif : « Angle », « G ») ne disait pas le côté ;
       l'atelier lisait « Droite » pour un L gauche. Elle porte le côté ; la carte du panier l'affiche telle quelle.*/
    var origProps = A.buildLineItemProperties;
    if (typeof origProps === 'function') {
      A.buildLineItemProperties = async function () {
        var p = await origProps.apply(this, arguments);
        try {
          var S = this.S, t = junctionText(this), f = typeof window.CP_formeName === 'function' ? window.CP_formeName(S) : '';
          if (p && f) p['Forme'] = f;                                       /*  nom unique de la forme (cp-modele)*/
          else if (p && S.layout === 'angle') p['Forme'] = S.angleDir === 'left' ? 'Angle gauche' : 'Angle droit';
          else if (p && S.layout === 'g-shape') p['Forme'] = S.gDir === 'left' ? 'G gauche' : 'G droit';
          if (t && p) p['Jonction'] = t;
        } catch (e) {}
        return p;
      };
    }

    /* moteur pas encore initialisé (pas de dessin) : son init fera le premier rendu */
    if (A.svg && A.dims) { try { A.render(); } catch (e) { console.warn('[cp-jct]', e); } }
  }

  var tries = 0;
  var timer = setInterval(function () {
    var A = getApp();
    if (A && A.S && A.__cpThkWrapped && typeof A.updateTdOptionsList === 'function') {
      clearInterval(timer); wrap(A);
    } else if (++tries > 400) clearInterval(timer);
  }, 50);

  /* Garde panier : 45° sans prix = jamais commandé à 0 € */
  window.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('#btn-add-cart'))) return;
    var A = getApp();
    if (A && A.S && n45(A) > 0 && !has45()) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (window.CFG_UI) window.CFG_UI.toast('La coupe à 45° n\'est pas proposée en ligne pour ce produit : choisissez une autre jonction, ou écrivez-nous.', 'error', 7000);   /* L49 (lot « messages 1 ») : sans « sur devis », sans préfixe */
    }
  }, true);
})();
